module.exports = __webpack_public_path__ + "img/login-1.db0e8c11.jpg";